import {action, observable, runInAction, toJS} from "mobx";
import {customEvent, lessonParamsForAnalytics} from "../../../utils/analyticsUtil";
import {actions, category, events} from "../../../constants/enums";
import manageStore from "../../../stores/ManageStore"
import appStore from "../../app/store";
import mainStore from "../store";
import schoolStore from "../schools/store";
import {getCurrentPageAction} from "../../../utils/navigationUtility";


class AssignStudentStore {
    @observable isAssignDialogOpen = false;
    @observable lesson;
    @observable lessonShareable;
    @observable selectedStudentList = [];
    @observable hasChanges = false;
    @observable submitted = null;

    @action onToggleAssignDialog = (lesson) => {
        this.isAssignDialogOpen = !this.isAssignDialogOpen;
        this.assignedStudentList = [];
        this.unassignedStudentsList = [];
        this.hasChanges = false;
        this.lesson = null;
        if (this.isAssignDialogOpen && lesson) {
            this.lesson = lesson;
            this.lessonShareable = schoolStore.activeSchool.sharingEnabled && lesson.isShareable
                || !schoolStore.activeSchool.id;
            // const assignedStudentList = (lesson.assignedUsers || []).map(s => ({...s, selected: true, assigned: true}));
            // const unassignedStudentsList = manageStore.enrichedStudentList
            //     .map(s => ({...s, selected: false}))
            //     .filter(s => !assignedStudentList.some(stud => stud.id === s.id));
            // this.selectedStudentList = assignedStudentList.concat(unassignedStudentsList);
            this.selectedStudentList = manageStore.enrichedStudentList.map(s => ({...s, selected: false}));
        }
    };

    @action toggleSelected = (student) => {
        student.selected = !student.selected;
        this.hasChanges = true;
    }

    @action onAssignSave = async (match) => {
        mainStore.toggleProgressLoader(true);
        this.submitted = true;
        let lesson = toJS(this.lesson);
        const selectedStudentsList = toJS(this.selectedStudentList);
        this.onToggleAssignDialog();
        try {
            const currentPage = getCurrentPageAction(match);
            selectedStudentsList.forEach(student => {
                if (student.selected) {
                    let params;
                    if (currentPage === actions.FromMusicoLibrary) {
                        params = {...lessonParamsForAnalytics(lesson)}
                    } else {
                        params = {label: student.name}
                    }
                    customEvent(events.CustomEvent, {
                        category: category.AssignLesson,
                        action: currentPage,
                        ...params
                    });
                }
            });
            return await manageStore.sendAssignedStudents(lesson.id, selectedStudentsList);
        } catch (err) {
            console.log('error assigning users:', err);
            appStore.createAlertFromMessageId('error', 'manage.assign.error');
        } finally {
            mainStore.toggleProgressLoader(false);
            runInAction(() => {
                this.submitted = false;
            });
        }
    }

}


const assignStudentStore = new AssignStudentStore();
export default assignStudentStore;
